<template>
    <table width="100%">
    <thead v-if="o != n">
        <tr>
            <th align="center" width="33%" style="padding-right: 5px;"><a @click="res = o">Старое</a></th>
            <th align="center" width="34%" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;"> ← diff →</th>
            <th align="center" width="33%" style="padding-left: 5px;"><a @click="res = n">Новое</a></th>
        </tr>
    </thead>
    <tbody v-if="o != n">
        <tr>
            <td :class="{'selected': (''+res) == (''+o)}" valign="top" style="padding-right: 5px;">
                <a @click="res = ''+o">{{unescapeHTML(strip_tags(o))}}</a>
            </td>
            <td valign="top" style="border-left: solid 1px lightgrey; border-right: solid 1px lightgrey; padding: 0 5px;">
                <span class="diff" v-html="diff"/>
            </td>
            <td :class="{'selected': ((''+res) == (''+n)) && ((''+o) != (''+n))}" valign="top" style="padding-left: 5px;">
                <a @click="res = ''+n">{{unescapeHTML(strip_tags(n))}}</a>
            </td>
        </tr>
    </tbody>

    <thead>
        <tr>
            <th align="center" colspan="3">Актуальное</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="selected" colspan="3">
                <v-quill ref="quill" v-model="res" :config="quillConfig"/>
            </td>
        </tr>
    </tbody>
    </table>
</template>
<script>
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";
import DiffMatchPatch from 'diff-match-patch';
import _ from "lodash";
export default {
    mixins:[Base,StrPropsFNO],
    props: {
        full: {
            type: Object,
            default: () => {},
        }
    },
    data: function () {
        return {

        }
    },
    methods: {
        getDiff: function(o, n){
            let dmp = new DiffMatchPatch();
            let d = dmp.diff_main(this.unescapeHTML(this.strip_tags(o)), this.unescapeHTML(this.strip_tags(n)));
            dmp.diff_cleanupEfficiency(d);
            return dmp.diff_prettyHtml(d);
        },
        textToEducations(text, index) {
            text = this.cutQuotes(text);
            text.split('\n').forEach((line) => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
                        if (acc === '') {
                            let y = parseInt(val);
                            if ((1970 <= y && y <= 2030)) {
                                return y;
                            } else if ((70 <= y && y <= 99)) {
                                return 1900 + y;
                            }
                        }
                        return acc;
                    }, '');

                    let speciality = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
                        if (acc === '') {
                            val = val.toLowerCase();

                            if (val.startsWith('лечебн')) {
                                return 'Лечебное дело';

                            } else if (val.startsWith('педиатр')) {
                                return 'Педиатрия';

                            } else if (val.startsWith('стоматолог')) {
                                return 'Стоматология';

                            } else if (val.startsWith('акушер')) {
                                return 'Акушерство и гинекология';

                            } else if (val.startsWith('гинеколог')) {
                                return 'Гинекология';

                            } else if (val.startsWith('терап')) {
                                return 'Терапия';

                            } else if (val.startsWith('хирург')) {
                                return 'Хирургия';

                            } else if (val.startsWith('невролог')) {
                                return 'Неврология';

                            } else if (val.startsWith('дерматовенерол')) {
                                return 'Дерматовенерология';

                            } else if (val.startsWith('офтальмолог')) {
                                return 'Офтальмология';

                            } else if (val.startsWith('уролог')) {
                                return 'Урология';

                            } else if (val.startsWith('психолог')) {
                                return 'Психология';

                            } else if (val.startsWith('фельдшер')) {
                                return 'Фельдшер';

                            } else if (val.startsWith('зубной')) {
                                return 'Стоматология';

                            } else if (val.startsWith('общей')) {
                                return 'Врач общей практики';

                            } else if (val.startsWith('эндокринолог')) {
                                return 'Эндокринология';

                            } else if (val.startsWith('кардиолог')) {
                                return 'Кардиология';

                            } else if (val.startsWith('психиатр')) {
                                return 'Психиатрия';

                            } else if (val.startsWith('оториноларинголог')) {
                                return 'Оториноларингология';

                            } else if (val.startsWith('рентгенолог')) {
                                return 'Рентгенология';

                            } else if (val.startsWith('терапевт')) {
                                return 'Терапевт';

                            } else if (val.startsWith('логопед')) {
                                return 'Логопедия';

                            } else if (val.startsWith('брат')) {
                                return 'Медицинский брат';

                            } else if (val.startsWith('сестр')) {
                                return 'Сестринское дело';

                            } else if (val.startsWith('массаж')) {
                                return 'Медицинский массаж';

                            } else if (val.startsWith('онколог')) {
                                return 'Онкология';

                            } else if (val.startsWith('дефектолог')) {
                                return 'Дефектология';

                            } else if (val.startsWith('отоларинголог')) {
                                return 'Отоларингология';

                            }
                        }
                        return acc;
                    }, '');

                    let grade = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
                        if (acc === '') {
                            val = val.toLowerCase();

                            if (val.startsWith('интерн')) {
                                return 'интернатура';

                            } else if (val.startsWith('ординат')) {
                                return 'ординатура';

                            } else if (val.startsWith('аспирант')) {
                                return 'аспирантура';

                            } else if (val.startsWith('доктор')) {
                                return 'докторантура';
                            }
                        }
                        return acc;
                    }, '');

                    let university = this.cutLastComma(_.upperFirst(line).trim())

                    if (index === null) {
                        // добавляем в конец если не задан индекс
                        if (
                            !!(this.full.education[this.full.education.length - 1]) &&
                            _.isEmpty(this.full.education[this.full.education.length - 1].univercity) &&
                            _.isEmpty(this.full.education[this.full.education.length - 1].year) &&
                            _.isEmpty(this.full.education[this.full.education.length - 1].speciality) &&
                            _.isEmpty(this.full.education[this.full.education.length - 1].grade)
                        ) {
                            this.full.education = this.full.education.slice(0, -1);
                        }

                        this.full.education.push({
                            univercity: university,
                            year: year,
                            speciality: speciality,
                            grade: grade
                        });
                    } else {
                        if (
                            !!(this.full.education[index]) &&
                            _.isEmpty(this.full.education[index].univercity) &&
                            _.isEmpty(this.full.education[index].year) &&
                            _.isEmpty(this.full.education[index].speciality) &&
                            _.isEmpty(this.full.education[index].grade)
                        ) {
                            this.full.education[index].univercity = university;
                            this.full.education[index].year = year;
                            this.full.education[index].speciality = speciality;
                            this.full.education[index].grade = grade;
                        } else {
                            this.full.education.splice(index, 0, {
                                univercity: university,
                                year: year,
                                speciality: speciality,
                                grade: grade
                            });
                            index++;
                        }
                    }
                }
            });
        },
        textToCertificates(text, index) {
            text = this.cutQuotes(text);
            text.split('\n').forEach(line => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
                        let y = parseInt(val);
                        if ((1970 <= y && y <= 2030)) {
                            acc.push('' + y);
                            return acc;
                        } else if ((70 <= y && y <= 99)) {
                            acc.push('' + (1900 + y));
                            return acc;
                        }
                        return acc;
                    }, []);

                    if (index === null) {
                        if (
                            !!(this.full.certificates[this.full.certificates.length - 1]) &&
                            _.isEmpty(this.full.certificates[this.full.certificates.length - 1].univercity) &&
                            _.isEmpty(this.full.certificates[this.full.certificates.length - 1].year[0])
                        ) {
                            this.full.certificates = this.full.certificates.slice(0, -1);
                        }

                        this.full.certificates.push({
                            univercity: this.cutLastComma(_.upperFirst(line).trim()),
                            year: year
                        });
                    } else {
                        this.full.certificates.splice(index, 0, {
                            univercity: this.cutLastComma(_.upperFirst(line).trim()),
                            year: year
                        });
                        index++;
                    }
                }
            });
            for (var i = 0; i < this.full.certificates.length; i++) {
                this.inputCertificateYear(i);
            }
        },
        inputCertificateYear(certIndex) {
            let lastYearIndex = this.full.certificates[certIndex].year.length - 1;

            if ((this.full.certificates[certIndex].year.length === 0) || (this.full.certificates[certIndex].year[lastYearIndex] !== '')) {
                this.full.certificates[certIndex].year.push("");
            }
        },
        textToEmployments(text, index) {
            text = this.cutQuotes(text);
            text.split('\n').forEach(line => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    let year = _.words(line.replace('–', ' ').replace('-', ' ')).reduce(function (acc, val) {
                        let y = parseInt(val);
                        if ((1900 <= y && y <= 2050)) {
                            acc.push('' + y);
                            return acc;
                        }
                        return acc;
                    }, []);

                    let data = {
                        name: this.cutLastComma(_.upperFirst(line).trim()),
                        position: '',
                        m1: '',
                        y1: year[0] || '',
                        m2: '',
                        y2: year[1] || '',
                        now: false
                    };

                    if (
                        !!(this.full.employment[this.full.employment.length - 1]) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].name) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].position) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].m1) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].m2) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].y1) &&
                        _.isEmpty(this.full.employment[this.full.employment.length - 1].y2)
                    ) {
                        this.full.employment = this.full.employment.slice(0, -1);
                    }

                    if (index === null) {
                        this.full.employment.push(data);
                    } else {
                        this.full.employment.splice(index, 0, data);
                        index++;
                    }
                }
            });
        },
        textToAssociations(text, index) {
            text = this.cutQuotes(text);
            text.split('\n').forEach(line => {
                line = line.trim();
                if (!_.isEmpty(line)) {
                    let data = this.cutLastComma(_.upperFirst(line).trim())
                    if (index === null) {
                        if(this.full.associations[this.full.associations.length - 1] === ''){
                            this.full.associations[this.full.associations.length - 1] = data;
                        }else{
                            this.full.associations.push(data);
                        }
                    } else {
                        this.full.associations.splice(index, 0, data);
                        index++;
                    }
                }
            });
        },
        cutQuotes(text) {
            if (text[0] === '«' && text[text.length - 1] === '»') {
                text = text.slice(1, text.length - 1);
            }

            return text;
        },
        cutLastComma(text) {
            if (text[text.length - 1] === ',') {
                text = text.slice(0, text.length - 1);
            }

            return text;
        },
    },

    mounted() {
        this.$bus.listen('moderateClinics', () => {
            if (this.$refs.quill !== undefined){
                this.$bus.fire('quillInProgress', this.$refs.quill.inProcess);
                if (this.$refs.quill.inProcess) {
                    this.$refs.quill.quillEditor.setSelection(null)
                }
            }
        })
    },
    computed: {
        diff: function (){
            return this.getDiff(this.o, this.n)
        },
        quillConfig() {
            let scope = this;

          if (scope.params.entity === 'promotion') {
            let container =  [{'list': 'bullet'}, 'clean', 'strike', 'textLowerCase'];

            return {
              modules: {
                toolbar: {
                  container: container,
                },
              },
              formats: ['list', 'indent', 'clean', 'strike'],
            };
          }

          if (scope.params.entity === 'clinic') {
              return {eventsOnBlur: true};
          }

          if (scope.params.entity !== 'doctor') {
              return {};
          }

            return {
                customEvents: {
                    onTextChange: (quill, delta, oldDelta, source) => {

                        var listChanged = delta
                            .filter((op) => (op.attributes || {}).list === "bullet")
                            .length;

                        if (listChanged) {
                            var deltaBefore = quill.getContents();
                            var deltaNew = new Delta();
                            deltaBefore.eachLine((line, attr, i) => {
                                var d = line;
                                if (attr.list === 'bullet') {
                                    var dText = d
                                        .filter((op) => typeof op.insert === 'string')
                                        .map((op) => op.insert)
                                        .join('');

                                    var prefix = dText.match(/^([-*•·▪▫‣◦+—.)\s]|(\d{1,2}[\)\.]))+/ig) || [''];
                                    d = d.slice(prefix[0].length);
                                }

                                d.insert('\n', attr);
                                deltaNew = deltaNew.concat(d);
                            });
                            quill.updateContents(deltaBefore.diff(deltaNew), 'api');
                        }
                    }
                },
                modules: {
                    toolbar: {
                        container: [
                            [
                                {'list': 'bullet'}, 'clean',
                                'textLowerCase', 'textToEducations', 'textToEmployments', 'textToCertificates',  'textToAssociations'
                            ],
                            ['textTemplate1']
                        ],

                        handlers: {
                            textToEducations() {
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    let text = this.quill.getText(range.index, range.length);
                                    this.quill.deleteText(range.index, range.length, 'api');
                                    this.quill.setSelection(range.index, 0);

                                    let index = null;
                                    scope.full.education.forEach((item, i) => {
                                        if (!item.univercity && index === null) {
                                            index = i;
                                        }
                                    });

                                    scope.textToEducations(text, index);
                                    scope.$root.$emit('education-changed', index)

                                    if (index === null || index === scope.full.education.length - 1) {
                                        scope.full.education.push({
                                            grade: '',
                                            speciality: '',
                                            univercity: '',
                                            year: ''
                                        })
                                    }
                                }
                            },
                            textToCertificates() {
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    let text = this.quill.getText(range.index, range.length);
                                    this.quill.deleteText(range.index, range.length, 'api');
                                    this.quill.setSelection(range.index, 0);

                                    scope.textToCertificates(text, null);

                                    scope.full.certificates.push({
                                        univercity: '',
                                        year: ['']
                                    })
                                }
                            },
                            textToEmployments: function () {
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    let text = this.quill.getText(range.index, range.length);
                                    this.quill.deleteText(range.index, range.length, 'api');
                                    this.quill.setSelection(range.index, 0);

                                    scope.textToEmployments(text, null);

                                    scope.full.employment.push({
                                        name: '',
                                        position: '',
                                        m1: '',
                                        y1: '',
                                        m2: '',
                                        y2: '',
                                        now: false
                                    })
                                }
                            },
                            textToAssociations: function () {
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    var text = this.quill.getText(range.index, range.length);
                                    this.quill.deleteText(range.index, range.length, 'api');
                                    this.quill.setSelection(range.index, 0);

                                    scope.textToAssociations(text, null);

                                    scope.full.associations.push('')
                                }
                            },
                            textLowerCase: function () {
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    var text = this.quill.getText(range.index, range.length);
                                    text = text.toLowerCase();
                                    this.quill.deleteText(range.index, range.length, 'api');
                                    this.quill.insertText(range.index, text, 'api');
                                    this.quill.setSelection(range.index + text.length, 0);
                                }
                            },
                            textTemplate1: function () {
                                let text = 'Профессиональные навыки: ';
                                let range = this.quill.getSelection();
                                if (range.length) {
                                    this.quill.deleteText(range.index, range.length, 'api');
                                }
                                this.quill.insertText(range.index, text, 'api');
                                this.quill.setSelection(range.index + text.length, 0);
                            },
                        }
                    },
                },
                eventsOnBlur: true
            };
        }
    }
}
</script>

<style lang="scss">
#doctorModeration .ql-textToList:after {
    content: "\f0ca";
    padding-right: 10px;
    font-size: 15px;
    margin-top: -2px;
}

.ql-textLowerCase {
    width: 42px !important;
}

.ql-textToEducations {
    margin-top: -3px !important;
    width: 50px !important;
}

.ql-textToCertificates {
    margin-top: -3px !important;
    width: 50px !important;
}

.ql-textToEmployments {
    margin-top: -3px !important;
    width: 50px !important;
}

.ql-textToAssociations {
    margin-top: -3px !important;
    width: 50px !important;
}

.ql-textTemplate1 {
    margin-top: -3px !important;
    width: 102px !important;
}

#doctorModeration .multiselect__single {
    max-width: calc(100% - 15px);
}

#doctorModeration .ql-toolbar .ql-formats:nth-child(2) {
    float: right;
    padding-right: 0;
    margin-right: 0;
}

#doctorModeration .ql-textLowerCase:after {
    content: "A→а";
    display: block;
    top: 0;
    padding-left: 10px;
}

#doctorModeration .ql-textToEducations:after {
    content: "→Обр";
    display: block;
    top: 0;
    padding-left: 10px;
}

#doctorModeration .ql-textToCertificates:after {
    content: "→Курс";
    display: block;
    top: 0;
    padding-left: 10px;
}

#doctorModeration .ql-textToEmployments:after {
    content: "→Раб";
    display: block;
    top: 0;
    padding-left: 10px;
}

#doctorModeration .ql-textToAssociations:after {
    content: "→Асс";
    display: block;
    top: 0;
    padding-left: 10px;
}

#doctorModeration .ql-textTemplate1:after {
    content: "Проф навыки";
    padding-right: 10px;
    display: block;
    top: 0;
}
</style>
